import React, {Component} from 'react';

class SectionEstratto  extends Component {
 
    render() {
        return (
            <section id={this.props.estrattoId} className="ftco-section img ftco-animate" style={this.props.estrattoStile}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 d-md-flexmb-5 heading-section text-left ftco-animate" >
                                <div className="text-panel">
                                    <h2 className="mb-4">{this.props.estrattoTitolo}</h2>
                                    <h3 dangerouslySetInnerHTML={{ __html: this.props.estrattoContenuto }}></h3>
                                </div>
                                {this.props.estrattoButtonLink ? (
                                    <>
                                        <br /><p className="mt-5"><a href={this.props.estrattoButtonLink} className="btn btn-info py-3 px-4" target="_blank" rel="noreferrer noopener">{this.props.estrattoButton}</a></p>
                                    </>
                                ) : null}
                            
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default SectionEstratto;